import { TermsSection } from 'app/src/features/Landing/components/TermsSection'
import { membershipApi } from 'app/src/services/welfareportal'
import { activeCampaigns, getFromSessionStorage } from 'app/src/shared/helpers'
import { useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { Sidebar } from 'primereact/sidebar'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function UserSidePanel() {
  const context = useWebAppContext()
  const campaign = getFromSessionStorage('selectedCampaign')

  const campaignName = campaign && JSON.parse(campaign)?.campaignName
  const membershipId = campaign && JSON.parse(campaign)?.membershipId

  const { t } = useTranslation('landing', { keyPrefix: 'Landing.UserSidePanel' })
  const globalTranslation = useTranslation('home', { keyPrefix: 'Global' })

  const navigate = useWelfarePortalNavigate()

  const membershipResponse = !context.userInfo.isForbidden
    ? membershipApi.useMembershipGet<membershipApi.MembershipExtended>(
        {
          pathParams: { membershipId: membershipId },
          queryParams: { includeFamilyMembers: true },
        },
        { enabled: !!membershipId },
      )
    : undefined

  const [canSelectCampaign, setCanSelectCampaign] = useState<boolean>(false)

  useEffect(() => {
    if (context.userInfo.isForbidden || context.userInfo.canSelfRegister) {
      setCanSelectCampaign(false)
    } else setCanSelectCampaign(activeCampaigns(context.userInfo.userMemberships).length >= 2)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.userInfo.isForbidden, context.userInfo.canSelfRegister])

  useEffect(() => {
    if (membershipResponse?.data?.welfareCampaign)
      context.update({ userInfo: { ...context.userInfo, welfareCampaign: membershipResponse?.data?.welfareCampaign } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membershipResponse?.data, membershipResponse?.data?.welfareCampaign])

  return (
    <div className='card justify-content-center'>
      <Sidebar
        className='w-[370px]'
        visible={context.showUserSidePanel}
        position={'right'}
        onHide={() => context.update({ showUserSidePanel: false })}
      >
        <p className='text-[32px] font-bold leading-[48px]'>
          {globalTranslation.t('Hello')} {context.userInfo?.firstName}
        </p>
        <br />
        {canSelectCampaign && activeCampaigns(context.userInfo.userMemberships).length >= 2 && (
          <Button
            label={campaignName}
            icon='pi pi-arrow-right-arrow-left'
            iconPos='right'
            className='mb-[16px] w-full rounded-3xl bg-[var(--primary-color)] p-[8px] text-[16px] font-semibold leading-[24px] text-white'
            onClick={() => context.update({ showCompanySelectionDialog: true })}
            pt={{ label: { className: 'text-[16px] font-semibold leading-[24px] pr-0' }, icon: { className: 'pr-6 pl-0' } }}
          />
        )}
        {membershipResponse?.data && (
          <div className='grid grid-cols-12 bg-[var(--informative-disclaimer-background)] p-[24px]'>
            <div className='col-span-12 col-start-1 text-[14px] font-semibold leading-[21px] text-[#7A7A7A] md:col-span-12 md:col-start-1'>
              {t('Email')}
            </div>
            <div
              id='userEmail'
              className='col-span-12 col-start-1 mb-[8px] truncate text-[16px] font-medium leading-[20px] md:col-span-12 md:col-start-1'
            >
              {membershipResponse.data.membershipInfo.userEmail?.toLocaleLowerCase()}
            </div>
            <div className='col-span-12 col-start-1 text-[14px] font-semibold leading-[21px] text-[#7A7A7A] md:col-span-12 md:col-start-1'>
              {t('Iban')}
            </div>
            <div className='col-span-12 col-start-1 mb-[16px] truncate text-[16px] font-medium leading-[20px] md:col-span-12 md:col-start-1'>
              {membershipResponse.data.membershipInfo.userIban}
            </div>
            {membershipResponse.data?.membershipInfo.userFamilyMembers && (
              <div className='col-span-12 col-start-1 mb-[16px] text-[14px] font-semibold leading-[21px] text-[#7A7A7A] md:col-span-12 md:col-start-1'>
                {t('Familymembers')}
              </div>
            )}
            {membershipResponse.data?.membershipInfo.userFamilyMembers &&
              membershipResponse.data?.membershipInfo.userFamilyMembers.map((familyMember) => (
                <div
                  key={familyMember.familyMemberId}
                  className='col-span-12 col-start-1 mb-[8px] truncate text-[16px] font-medium capitalize leading-[20px] md:col-span-12 md:col-start-1'
                >
                  {familyMember?.firstName?.toLowerCase()} {familyMember?.lastName?.toLowerCase()}
                </div>
              ))}
            <div className='col-span-12 col-start-1 mt-[16px] md:col-span-12 md:col-start-1'>
              <Button
                autoFocus
                disabled={context.userInfo.isForbidden}
                onClick={() => navigate.goToUserInfo()}
                className='grid min-h-[44px] min-w-[171px] rounded-3xl px-[16px] py-[8px] text-center text-[16px] font-semibold leading-[24px]'
              >
                {t('ButtonLabelUserData')}
              </Button>
            </div>
          </div>
        )}
        <TermsSection />
        <Button
          label={t('ButtonLabelExit')}
          text
          className='mt-[30px] p-0 text-left'
          icon='pi pi-sign-out'
          iconPos='left'
          pt={{ label: { className: 'text-[15px] font-semibold leading-[22px]' }, icon: { className: 'text-[15px]' } }}
          onClick={() => {
            sessionStorage.setItem('spendingReminderShown', 'true')
            window.open('logout', '_self')
          }}
        />
      </Sidebar>
    </div>
  )
}
